var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exibition",class:{ active: _vm.exibition}})}
var staticRenderFns = []

export { render, staticRenderFns }